import { CourierWhoAmIDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useMemo } from 'react';
import { useImmer } from 'use-immer';
import { parseErrorMessage } from '../../../core/api/api.context';
import { useMutationCourierLoginTest } from './courier-login-testing.queries';
import { Courier } from './models/courier.model';

interface State {
  whoAmI: CourierWhoAmIDto | null;
  couriers: Courier[];
  errorMessage: string | null;
}

const initialState: State = {
  whoAmI: null,
  couriers: [],
  errorMessage: null
};

export function useCourierLoginTesting() {
  const [state, setState] = useImmer<State>(initialState);
  const courierLoginMutation = useMutationCourierLoginTest();

  function handleResponse(data: CourierWhoAmIDto) {
    setState((draft) => {
      draft.whoAmI = data;
      draft.couriers = data.couriers.map((courier) => new Courier(courier));
    });
  }

  function onSubmit(mobile: string) {
    setState(() => initialState);

    courierLoginMutation.mutate(
      { mobile },
      {
        onSuccess: handleResponse,
        onError(error) {
          setState((draft) => {
            draft.errorMessage = `Error: ${parseErrorMessage(error.message)}`;
          });
        }
      }
    );
  }

  const couriersList = useMemo(() => {
    const searchPriority = (carrier: Courier['carrier']) =>
      (carrier as { searchPriority?: number }).searchPriority ?? 99;

    const sortedCouriers = [...state.couriers].sort((a, b) => searchPriority(a.carrier) - searchPriority(b.carrier));

    return sortedCouriers;
  }, [state.couriers]);

  return {
    state,
    couriersList,
    isLoading: courierLoginMutation.isLoading,
    isError: courierLoginMutation.isError,
    onSubmit
  };
}
